module.exports = __webpack_public_path__ + "static/media/upcoming_game_1.5c731a25.png";